import { forwardRef } from 'react';

import type { SVGIconProps } from '../types';

export const PortUsbMiniIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = 'currentColor', size = 16, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_51_317"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_51_317)">
        <path
          d="M3.39753 7.74826C3.39753 7.64377 3.48224 7.55907 3.58672 7.55907H12.4786C12.5831 7.55907 12.6678 7.64377 12.6678 7.74826V9.26177C12.6678 9.36626 12.5831 9.45096 12.4786 9.45096H3.58672C3.48224 9.45096 3.39753 9.36626 3.39753 9.26177V7.74826Z"
          fill={color}
        />
        <path
          d="M3.9651 6.9915C3.9651 6.88701 4.04981 6.80231 4.15429 6.80231H4.81645C4.92094 6.80231 5.00564 6.88701 5.00564 6.9915V9.07258C5.00564 9.17707 4.92094 9.26177 4.81645 9.26177H4.15429C4.04981 9.26177 3.9651 9.17707 3.9651 9.07258V6.9915Z"
          fill={color}
        />
        <path
          d="M5.72456 6.9915C5.72456 6.88701 5.80926 6.80231 5.91375 6.80231H6.57591C6.6804 6.80231 6.7651 6.88701 6.7651 6.9915V9.07258C6.7651 9.17707 6.6804 9.26177 6.57591 9.26177H5.91375C5.80926 9.26177 5.72456 9.17707 5.72456 9.07258V6.9915Z"
          fill={color}
        />
        <path
          d="M7.48402 6.9915C7.48402 6.88701 7.56873 6.80231 7.67321 6.80231H8.33537C8.43986 6.80231 8.52456 6.88701 8.52456 6.9915V9.07258C8.52456 9.17707 8.43986 9.26177 8.33537 9.26177H7.67321C7.56873 9.26177 7.48402 9.17707 7.48402 9.07258V6.9915Z"
          fill={color}
        />
        <path
          d="M9.24348 6.9915C9.24348 6.88701 9.32819 6.80231 9.43267 6.80231H10.0948C10.1993 6.80231 10.284 6.88701 10.284 6.9915V9.07258C10.284 9.17707 10.1993 9.26177 10.0948 9.26177H9.43267C9.32819 9.26177 9.24348 9.17707 9.24348 9.07258V6.9915Z"
          fill={color}
        />
        <path
          d="M11.0029 6.9915C11.0029 6.88701 11.0876 6.80231 11.1921 6.80231H11.8543C11.9588 6.80231 12.0435 6.88701 12.0435 6.9915V9.07258C12.0435 9.17707 11.9588 9.26177 11.8543 9.26177H11.1921C11.0876 9.26177 11.0029 9.17707 11.0029 9.07258V6.9915Z"
          fill={color}
        />
        <path
          d="M14.2432 5.25682C14.2432 5.15233 14.3279 5.06763 14.4324 5.06763H14.8108C14.9153 5.06763 15 5.15233 15 5.25682V6.95952C15 7.06401 14.9153 7.14871 14.8108 7.14871H14.4324C14.3279 7.14871 14.2432 7.06401 14.2432 6.95952V5.25682Z"
          fill={color}
        />
        <path
          d="M1 5.25682C1 5.15233 1.0847 5.06763 1.18919 5.06763H1.56757C1.67205 5.06763 1.75676 5.15233 1.75676 5.25682V6.90928C1.75676 6.9422 1.76535 6.97455 1.78168 7.00314L2.48859 8.24022C2.50492 8.26881 2.51351 8.30116 2.51351 8.33408V10.7433C2.51351 10.8478 2.42881 10.9325 2.32432 10.9325H1.94595C1.84146 10.9325 1.75676 10.8478 1.75676 10.7433V8.52327C1.75676 8.49035 1.74816 8.458 1.73183 8.42941L1.02493 7.19233C1.00859 7.16374 1 7.13139 1 7.09847V5.25682Z"
          fill={color}
        />
        <path
          d="M15 5.25682C15 5.15233 14.9153 5.06763 14.8108 5.06763H14.4324C14.3279 5.06763 14.2432 5.15233 14.2432 5.25682V6.90928C14.2432 6.9422 14.2347 6.97455 14.2183 7.00314L13.5114 8.24022C13.4951 8.26881 13.4865 8.30116 13.4865 8.33408V10.7433C13.4865 10.8478 13.5712 10.9325 13.6757 10.9325H14.0541C14.1585 10.9325 14.2432 10.8478 14.2432 10.7433V8.52327C14.2432 8.49035 14.2518 8.458 14.2682 8.42941L14.9751 7.19233C14.9914 7.16374 15 7.13139 15 7.09847V5.25682Z"
          fill={color}
        />
        <path
          d="M14.0541 10.1757C14.1585 10.1757 14.2432 10.2604 14.2432 10.3649V10.7433C14.2432 10.8478 14.1585 10.9325 14.0541 10.9325L1.94595 10.9325C1.84146 10.9325 1.75676 10.8478 1.75676 10.7433L1.75676 10.3649C1.75676 10.2604 1.84146 10.1757 1.94595 10.1757L14.0541 10.1757Z"
          fill={color}
        />
        <path
          d="M14.8108 5.06763C14.9153 5.06763 15 5.15233 15 5.25682V5.6352C15 5.73968 14.9153 5.82438 14.8108 5.82438L1.18919 5.82438C1.0847 5.82438 1 5.73968 1 5.63519L1 5.25682C1 5.15233 1.0847 5.06763 1.18919 5.06763H14.8108Z"
          fill={color}
        />
      </g>
    </svg>
  ),
);

PortUsbMiniIcon.displayName = 'PortUsbMiniIcon';
